import React from 'react';

class IconInstagramComponent extends React.Component {
  render() {
    const { className, color = 'currentColor' } = this.props;

    return (
      <svg
        className={className}
        width="21"
        height="21"
        viewBox="0 0 21 21"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
      >
        <g fill={color} fillRule="evenodd">
          <path d="M16.06 3.689a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5M10.5 13.973a3.473 3.473 0 11.003-6.947 3.473 3.473 0 01-.003 6.947m0-8.822a5.35 5.35 0 100 10.698 5.349 5.349 0 100-10.698m8.48 9.558c-.047 1.016-.217 1.567-.36 1.934-.19.487-.414.834-.779 1.198a3.185 3.185 0 01-1.198.778c-.366.144-.918.313-1.934.36-1.098.05-1.427.061-4.21.061-2.78 0-3.11-.011-4.208-.061-1.016-.047-1.567-.216-1.934-.36a3.201 3.201 0 01-1.198-.778 3.227 3.227 0 01-.78-1.198c-.142-.367-.312-.918-.358-1.934-.05-1.098-.06-1.428-.06-4.208 0-2.783.01-3.112.06-4.21.046-1.016.216-1.567.359-1.934.188-.488.414-.834.779-1.198.365-.365.712-.59 1.198-.78.367-.143.918-.312 1.934-.358 1.098-.05 1.427-.06 4.209-.06 2.782 0 3.111.01 4.209.06 1.016.046 1.568.215 1.934.359a3.2 3.2 0 011.198.779c.365.364.59.71.78 1.198.142.367.312.918.359 1.934.05 1.098.06 1.427.06 4.21 0 2.78-.01 3.11-.06 4.208m1.875-8.503c-.051-1.11-.227-1.867-.484-2.53a5.096 5.096 0 00-1.203-1.844A5.11 5.11 0 0017.324.63c-.664-.257-1.42-.435-2.53-.483C13.684.095 13.329.083 10.5.083c-2.828 0-3.184.013-4.294.064-1.11.049-1.867.226-2.53.483a5.115 5.115 0 00-1.844 1.202A5.097 5.097 0 00.63 3.677c-.257.662-.433 1.42-.483 2.529-.052 1.11-.064 1.466-.064 4.295 0 2.827.013 3.183.064 4.293.05 1.109.226 1.867.483 2.529a5.118 5.118 0 001.202 1.845c.58.58 1.16.935 1.845 1.201.662.258 1.42.435 2.529.485 1.11.05 1.466.063 4.294.063 2.829 0 3.184-.012 4.294-.063 1.11-.05 1.866-.227 2.53-.485a5.104 5.104 0 001.844-1.2 5.12 5.12 0 001.203-1.846c.257-.662.433-1.42.484-2.529.049-1.11.061-1.466.061-4.293 0-2.83-.012-3.186-.061-4.295" />
        </g>
      </svg>
    );
  }
}

export default IconInstagramComponent;
